<template>
    <div :class="{'show': item.collapsed}" class="card card-toggle card-alert cursor-pointer" v-data-href :key="index" @click="item.collapsed = !item.collapsed">
        <div class="card-body">
            <div class="card-body d-flex justify-content-between align-items-center pt-0">
                <h2>{{ item.title }}</h2>
                <i class="far fa-angle-down"></i>
            </div>
        </div>
        <transition-slide-toggle>
            <div class="card-footer" v-show="!item.collapsed">
                <p class="card-title">{{ item.tekst }}</p>
            </div>
        </transition-slide-toggle>
    </div>
</template>

<script>
    export default {
        props: {
            index: Number,
            rawItem: Object,
        },
        data() {
            return {
                item : {
                    collapsed: true,
                    title: this.rawItem.title,
                    tekst: this.rawItem.tekst,
                }
            }
        },
    }
</script>
